import { Reducer } from 'redux';

// Actions

export const displayGlobalError = (
  errorMessage: string,
  errorType: 'error' | 'warning' = 'error',
  subMessage?: string
) => ({
  type: 'DISPLAY_GLOBAL_ERROR' as const,
  errorMessage,
  subMessage,
  errorType,
});

export const hideGlobalError = () => ({ type: 'HIDE_GLOBAL_ERROR' as const });

type ErrorModalAction = ReturnType<
  typeof displayGlobalError | typeof hideGlobalError
>;

// Reducer

type ErrorModal = {
  errorMessage?: string;
  subMessage?: string;
  errorType?: 'error' | 'warning';
};

export const errorModalReducer: Reducer<ErrorModal, ErrorModalAction> = (
  state = {
    errorMessage: undefined,
    subMessage: undefined,
    errorType: undefined,
  },
  action
): ErrorModal => {
  switch (action.type) {
    case 'DISPLAY_GLOBAL_ERROR':
      return {
        errorMessage: action.errorMessage,
        errorType: action.errorType,
        subMessage: action.subMessage,
      };
    case 'HIDE_GLOBAL_ERROR':
      return { errorMessage: undefined };
    default:
      return state;
  }
};
